import axios from 'axios'
import { apiUrl } from '@/config.js';


const axiosAuthImpl = axios.create({
	timeout: 100000,
	crossDomain: true,
	headers: {
		'Content-Type': 'application/json',
	}
})

axiosAuthImpl.interceptors.request.use(
	(config) => {
		let contextoPix = JSON.parse(localStorage.getItem('contextoPix') );
		let tokenPix = JSON.parse(localStorage.getItem('tokenPix') );
		let x_flowId = JSON.parse(localStorage.getItem('flowid') );
		let x_tenant = JSON.parse(localStorage.getItem('tenant') );

		config.headers['Content-Type'] = 'application/json';
		config.headers['Access-Control-Allow-Credentials'] = 'true';
		config.headers['Access-Control-Expose-Headers'] = "Access-Control-*";
        config.headers['Access-Control-Allow-Headers'] = "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept, x-tenant, x-flowId";
        config.headers['Access-Control-Allow-Methods'] = "GET, POST, PUT, PATCH, DELETE, OPTIONS, HEAD";
        config.headers['Access-Control-Allow-Origin'] = "*";

		if (tokenPix) {
			config.headers['Authorization'] = `Bearer ${tokenPix}`;
        }

		if (x_flowId) {
			config.headers['x-flowId'] = x_flowId;
        }
		if (x_tenant) {
			config.headers['x-tenant'] = x_tenant;
        }

		if (contextoPix) {
			config.baseURL = contextoPix;
        }

		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export default axiosAuthImpl